<template>
    <div>
        <el-drawer :append-to-body="true" :visible.sync="drawer" :before-close="handleClose4" size="50%">
          <div>
            <BjPage ref="BjPage" :query-params="queryParams" :get-action="queryApi" :search-btn-hide="true" :serial="serial" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
              <template v-slot:tableOperation>
                  <el-col>
                      <el-button type="primary" class="main-btn" @click="onAdd()">{{$t('createText')}}</el-button>
                  </el-col>
              </template>
              <template v-slot:tableColumn>
                <template v-for="(col, index) in dropCols">
                  <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
                    <template slot-scope="scope">
                      <template v-if="false" />
                      <template v-else-if="col.prop === 'profitMargin'">
                          <span>{{ scope.row[col.prop] }} %</span>
                      </template>
                      <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
                    <template slot-scope="props">
                        <el-button type="text" class="view-btn" size="small" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
                        <el-button type="text" class="delete-btn" size="small" @click="insideFormDel(props.row)">{{ $t('delText') }}</el-button>
                    </template>
                  </el-table-column>
                </template>
              </template>
             </BjPage>
          </div>
        </el-drawer>
    </div>
</template>

<script>
import pageMiXin from '@/utils/page-mixin.js';
import { logisticApi } from '@/api';
export default {
    mixins: [pageMiXin],
    data() {
        return {
            colSpan: 4,
            drawer: false,
            innerDrawer: false,
            queryApi: logisticApi.getLogisticGroup,
            queryParams:{
                logisticsNameId:null,
            },
            labelList: [
                {label: this.$t('billingPage.zoneGroup'),prop: 'logisticsGroupName',isCheck: true,disabled: false,},
                {label: this.$t('businessLogisticsCompanyBusiness.table.ProfitMargin'),prop: 'profitMargin',isCheck: true,disabled: false,},
                {label: this.$t('table.operationText'),prop: 'bjTableAction',isCheck: true,disabled: false,width: 160,},
            ],
        };
    },
    methods: {
        onAdd(){
            this.$emit('openInsideDialog');
        },
        onEdit(row){
            this.$emit('openInsideDialog',row);
        },
        insideFormDel(row){
            this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
              confirmButtonText: this.$t('toast.okText'),
              cancelButtonText: this.$t('toast.cancelText'),
              type: 'warning',
            }).then(() => {
              logisticApi.delLogisticGroup({ids: [row.id]}).then(res => {
                if(!res.failed){
                  this.msgSuccess(this.$t('toast.operationSuccessText'));
                  this.$emit('reFresh');
                  this.homeReFresh()
                  this.reFresh();
                }
              });
            })
        },
        handleClose4() {
            this.drawer = false
        },
        homeReFresh() {
          this.$emit('homeReFresh');
        },
    },
};
</script>
<style lang="scss" scoped>
  ::v-deep .el-drawer__body {
    overflow: auto;
    padding: 16px;
  }
</style>